import { useStore } from 'effector-react'
import {
  CarImage,
  Descriptions,
  EmptyRentalContract,
  Booking,
  CarAccessControl,
  useRentalContractStatus,
} from '~/entities/RentalContract'
import { rentalContractModel } from '~/entities/RentalContract'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { CancellationInProgressWarning } from './ui/CancellationInProgressWarning'
import { EditRentalServices } from './ui/EditRentalServices'
import { SignedWarning } from './ui/SignedWarning'

export function RentalContract() {
  const rentalContractPending = useStore(
    rentalContractModel.getRentalContractFx.pending,
  )
  const rentalContract = useStore(rentalContractModel.$rentalContract)
  const status = rentalContract?.getStatus()

  const carImage = rentalContract?.getCarImage()

  const {
    isActive,
    isSigning,
    isSigned,
    isCancellationInProgress,
    isSuspended,
  } = useRentalContractStatus()

  if (rentalContractPending) return <ProgressBlock height={364} />
  if (!rentalContractPending && !rentalContract) return <EmptyRentalContract />

  return (
    <div data-testid={`main-booking-car-block-${status}`}>
      {carImage && <CarImage src={carImage} />}

      {(isSigning || isSigned) && <Booking />}

      {isSigned && <SignedWarning />}

      {isCancellationInProgress && <CancellationInProgressWarning />}

      {(isActive || isSuspended) && <CarAccessControl />}

      <div style={{ marginBottom: '24px' }}>
        <Descriptions />
      </div>

      <EditRentalServices />
    </div>
  )
}
